import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class PostDatedChequeProcessingQueueHistoryService extends BaseApiTemplateService<any> {

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/post-dated-cheque-processing-queue-histories/backoffice-ep";
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/post-dated-cheque-processing-queue-histories/backoffice-ep";
        this.httpClient = http;
      }
    
}